import { Outlet, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons';

// HEADER
const Layout = () => {
  const navigate = useNavigate();

  // Redirect to external page
  function handlePageRedirect(url) {
    if (url) window.open(url, '_blank', 'noopener noreferrer');
  }

  return (
    <div className="App">
      <header className="header">
        <div className="header-left">
          <span className="logo max-w-10" onClick={() => navigate('/')}>
            曾
          </span>
          <div className="flex flex-col items-start pl-3">
            <span className="text-lg font-medium hover cursor-pointer" onClick={() => navigate('/')}>
              Kyle Tseng
            </span>
            <span className="text-xs text-muted-foreground">Full Stack Developer</span>
          </div>
        </div>
        <div className="header-right">
          <span onClick={() => handlePageRedirect('https://github.com/Kylet1699')}>
            <FontAwesomeIcon icon={faGithub} className="text-3xl" />
          </span>
          <span onClick={() => handlePageRedirect('https://www.linkedin.com/in/kyletseng/')}>
            <FontAwesomeIcon icon={faLinkedin} className="text-3xl" />
          </span>
        </div>
      </header>
      <button className="scroll-to-top" onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}>
        <p>TO TOP</p>
        <FontAwesomeIcon icon={faArrowRightLong} className="text-lg icon" />
      </button>
      <Outlet />
    </div>
  );
};

export default Layout;
